import { useTranslation } from "react-i18next";

import Header from "@components/configurations/header";
import {ReactComponent as UsersIcon} from "@assets/sideMenuIcon/users.svg"
import UsersTable from "@components/configurations/users_config/users";

export const Users = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <Header title={t("Users")} icon={<UsersIcon fill={"#707070"} />}/>
      <UsersTable/>
    </>
  );
};
